import { Action, Types } from "./requests.actions"

export type RequestState = {
  errors: {}
  loading: boolean
}

const initialState: RequestState = {
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): RequestState => {
  switch (action.type) {
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH:
      return {
        ...state,
        loading: true,
      }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
